import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  methods: {
    $can(permission) {
      const { permissions: list } = usePage().props.value
      return (permission in list) && list[permission]
    },

    $canAny(permissionsList) {
      return permissionsList.some(name => this.$can(name))
    },
  },
}
